import React from 'react';
import {IDevice, sessionDevicesItems} from "../../mocks/sessionsDevicesItems.tsx";
import SessionDevice from "./SassionDevice.tsx";

const Sessions: React.FC = () => (
  <>
    <div className="mb-8 h4 md:mb-6">Your sessions</div>
    <div className="mb-8 base2 text-n-400 md:mb-6">
      This is a list of devices that have logged into your account. Revoke
      any sessions that you do not recognize.
    </div>
    <div className="py-3 base2 text-n-400">Devices</div>
    <div className="mb-6 max-h-[400px] overflow-y-auto">
      {sessionDevicesItems.map((device: IDevice) => (
        <SessionDevice item={device} key={device.id}/>
      ))}
    </div>
    <button className="btn-blue w-full">Sign out all devices</button>
  </>
);

export default Sessions;
